import { render } from "./SpeakerEditPage.vue?vue&type=template&id=0c80d342"
import script from "./SpeakerEditPage.vue?vue&type=script&lang=js"
export * from "./SpeakerEditPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__